import React, { useState } from "react";
import { 
  Calculator, 
  Info, 
  RefreshCcw 
} from "lucide-react";

// ============================================================================
// 🚀 TELA DE SIMULAÇÃO (IMOBILIÁRIA)
// ============================================================================
const SimuladorPage = () => {
  // ==========================================
  // ESTADOS DO SIMULADOR DE RENDA
  // ==========================================
  const [rendaBruta, setRendaBruta] = useState("");

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} e
   */
  const handleInputChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); 
    if (value === "") {
      setRendaBruta("");
      return;
    }
    const numberValue = parseInt(value, 10) / 100;
    setRendaBruta(
      new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(numberValue)
    );
  };

  const rawValue = parseFloat(rendaBruta.replace(/\./g, "").replace(",", ".")) || 0;
  const valorLocaticio = rawValue / 3;

  /**
   * @param {number} value
   */
  const formatBRL = (value) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  };

  const limparCampos = () => {
    setRendaBruta("");
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8 bg-slate-50 min-h-full font-sans animate-fade-in">
      <div className="max-w-5xl mx-auto space-y-8">
        
        {/* HEADER DA PÁGINA */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 border-b border-slate-200 pb-6">
          <div>
            <h1 className="text-2xl font-bold text-slate-800 flex items-center">
              <Calculator className="w-7 h-7 mr-3 text-brand-primary" />
              Simulador de Renda
            </h1>
            <p className="text-slate-500 font-medium mt-2 max-w-2xl text-sm">
              Simule o valor locatício ideal com base na regra de 1/3 da renda bruta somada antes de iniciar a ficha.
            </p>
          </div>
          <button 
            onClick={limparCampos}
            className="flex items-center gap-2 px-5 py-2.5 text-sm font-semibold text-slate-600 bg-white border border-slate-200 rounded-full hover:bg-slate-100 transition-colors shadow-sm shrink-0"
          >
            <RefreshCcw className="w-4 h-4" />
            Limpar
          </button>
        </div>

        {/* BLOCO: SIMULADOR DE RENDA */}
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 lg:gap-8">
          
          <div className="lg:col-span-3">
            <div className="bg-white rounded-2xl border border-slate-200 p-6 sm:p-8 shadow-sm h-full flex flex-col justify-center">
              <h2 className="text-lg font-semibold text-slate-800 mb-6 border-b border-slate-100 pb-4 flex items-center gap-2">
                <Calculator className="w-5 h-5 text-slate-400" /> Calculadora de 1/3
              </h2>

              <div>
                <label className="block text-sm font-semibold text-slate-600 mb-2">
                  Valor da renda bruta somada
                </label>
                <div className="relative">
                  <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                    <span className="font-semibold text-slate-400 text-lg">R$</span>
                  </div>
                  <input
                    type="text"
                    value={rendaBruta}
                    onChange={handleInputChange}
                    placeholder="0,00"
                    className="block w-full pl-12 pr-4 py-4 bg-slate-50 border border-slate-200 rounded-xl text-xl font-semibold focus:outline-none focus:border-brand-primary focus:ring-1 focus:ring-brand-primary text-slate-800 transition-all shadow-inner"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="bg-gradient-to-br from-teal-500 to-brand-primary rounded-2xl p-1 shadow-md overflow-hidden h-full">
              <div className="bg-white rounded-xl p-6 h-full flex flex-col justify-center">
                <h3 className="text-base font-semibold text-slate-800 mb-4 border-b border-slate-100 pb-3">
                  Resultado Máximo Permitido
                </h3>
                <div className="bg-teal-50 rounded-xl p-5 border border-teal-100 mt-2">
                  <p className="text-sm font-semibold text-teal-700 mb-1">
                    Valor Locatício Ideal
                  </p>
                  <div className="flex items-baseline gap-1">
                    <span className="text-3xl font-bold text-teal-800 tracking-tight">
                      {formatBRL(valorLocaticio)}
                    </span>
                  </div>
                  <p className="text-xs font-medium text-teal-600 mt-3 flex items-start gap-1">
                    <Info className="w-4 h-4 shrink-0" />
                    Aluguel + Condomínio + IPTU + Encargos
                  </p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SimuladorPage;